export type NameType = 'logoExpanding';

export const name: NameType = 'logoExpanding';
